import { PureComponent } from 'react';

export const withScrollTop = (ownProps) => (Component) =>
  class ComponentWithScrollTop extends PureComponent {
    componentDidMount() {
      window.scrollTo(0, 0);
    }

    render() {
      return <Component {...this.props} {...ownProps} />;
    }
  };
